import { Component, OnInit } from '@angular/core';
import { gutil} from '../gutil';
import { HttpClient } from '@angular/common/http'
import { faDumbbell, faBuilding, faHospital, faParking , faShoppingCart, faTableTennis, faMapMarkerAlt, faUtensils } from '@fortawesome/free-solid-svg-icons'

@Component({
  selector: 'app-top-living-areas',
  templateUrl: './top-living-areas.component.html',
  styleUrls: ['./top-living-areas.component.scss']
})
export class TopLivingAreasComponent implements OnInit {

  public faDumbbell = faDumbbell;
  public faUtensils = faUtensils;
  public faBuilding = faBuilding;
  public faHospital = faHospital;
  public faParking = faParking;
  public faShoppingCart = faShoppingCart;
  public faTableTennis = faTableTennis;
  public faMapMarkerAlt  = faMapMarkerAlt;
  public cityName:string;
  public genderSel:any;
  public selectedGen:any;
  public radiusSel:any; 
  public propertySel:any;
  public selectPropType:any;
  public selectRadius:any;
  public city_val:any = 'blr';
  
  public top_areas:any = 'HSR Layout';
  public searchProp:any;
  public topLivProp:any;
  public propList = [];
  public loader : boolean;

  constructor(private http: HttpClient) { 
    this.genderSel = gutil.genderSel;
    this.radiusSel = gutil.radiusSel;
    this.propertySel = gutil.propTypeSel;
  }

  ngOnInit(): void {
    window.scroll(0,0);
    this.selectedGen = 0;
    this.selectPropType = 0;
    this.selectRadius = 0;
    this.topCityAreas(this.city_val);
    this.cityTopAreas(0 , this.top_areas);
    this.loader = true;
  }
  public topCityAreas(value:any) {
    if(value == 'blr') {
      this.cityName = 'bengaluru';
      document.getElementById('blr').classList.add('activeCity');
      document.getElementById('pune').classList.remove('activeCity');
    }
    else {
      this.cityName = 'pune';
      document.getElementById('blr').classList.remove('activeCity');
      document.getElementById('pune').classList.add('activeCity');
    }
  }
  public cityTopAreas(chk: number , value:any){
    this.top_areas = value;
    this.top_areas =  this.top_areas.toLowerCase();
    this.getProp(this.top_areas);
    if(chk == 1){
      let el = document.getElementById("top_loc_props");
      el.scrollIntoView({behavior: 'smooth'});
    }
  }
  public getProp(top_areas: any) {
    this.loader = true;
      this.searchProp = "columns[city]=";
      this.searchProp = "columns[city]="+this.cityName + "&columns[gender]=1" + "&columns[sharetype]=0" ;
    

    this.http.get('https://api.yourownroom.com/api/w/v1/search/property?' + this.searchProp) 
        .subscribe((data:any) => {
          this.loader = false;
          this.topLivProp = data.data;
          this.propList = [];
          let tp = 0;
            for(let x = 0; x < this.topLivProp.length; x++) {
              if(this.topLivProp[x].property.locality.toLowerCase() == top_areas) {
                this.propList[tp] = this.topLivProp[x].property;
                console.log(this.propList);
                tp++;
              }
            }
        })
  }

}
